export { Spaced, SpacedProps } from './Spaced';
